<template>
  <div class="solution-container">
    <img src="@/assets/images/solution-bg.png" alt="" />
    <div class="solution-body-container">
      <!-- 左导航区域 -->
      <div class="solution-left-bar-container">
        <div
          class="solution-left-bar-wrapper wow fadeInLeft"
          data-wow-duration="0.5s"
        >
          <div class="solution-title">
            <span class="main-title">解决方法</span>
            <span class="sub-title">SOLUTION</span>
          </div>
          <div class="detail-btn-container">
            <div class="detail-btn" @click="toLink('solution')">
              <span>了解详情</span>
            </div>
          </div>
          <div class="bar-list-container">
            <ul>
              <div class="wave wave-white" v-for="item in solutionData" :key="item.id">
                <li
                  :class="{ active: item.id == activeData.id }"
                  @click="activeChange(item)"
                >
                  {{ item.title }}
                </li>
              </div>
            </ul>
          </div>
        </div>
      </div>

      <!-- 右body区域 -->
      <div class="solution-right-body-container">
        <div
          class="fadeInUpsolution-right-body-warpper wow fadeInRight"
          data-wow-duration="0.5s"
        >
          <div class="right-body-title fadeIn">
            <span>{{ activeData.data.title }}</span>
          </div>
          <div
            class="solution-content-container"
            v-for="item in activeData.data.content"
            :key="item.title"
          >
            <div class="solution-content-title">
              <span>{{ item.title }}</span>
            </div>
            <div class="solution-content-value">
              <span>{{ item.txt }}</span>
              <!-- <span> {{item.txt}}</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeData: {
        id: 1,
        title: "客户数据智能化",
        data: {
          title: "客户数据智能化解决方案",
          content: [
            {
              title: "客户分资源登记",
              txt: "保留客户每条可溯源记录，使检索信息更加高效",
            },
            {
              title: "客户数据统一关联",
              txt: "资源信息统一关联至客户，杜绝数据丢失、重复等问题",
            },
            {
              title: "客户数据可视化",
              txt: "精准分析客户数据信息，为销售和服务提供可靠数据支撑",
            },
          ],
        },
      },
      solutionData: [
        {
          id: 1,
          title: "客户数据智能化",
          data: {
            title: "客户数据智能化解决方案",
            content: [
              {
                title: "客户分资源登记",
                txt: "保留客户每条可溯源记录，使检索信息更加高效",
              },
              {
                title: "客户数据统一关联",
                txt: "资源信息统一关联至客户，杜绝数据丢失、重复等问题",
              },
              {
                title: "客户数据可视化",
                txt: "精准分析客户数据信息，为销售和服务提供可靠数据支撑",
              },
            ],
          },
        },
        {
          id: 2,
          title: "客户全程随访",
          data: {
            title: "客户全程随访解决方案",
            content: [
              {
                title: "线上电话外呼",
                txt: "线上快速外呼客户电话，保留与客户的通话记录和相关信息",
              },
              {
                title: "线上短信群发",
                txt: "线上短信批量群发，通过定义短信模板，批量送达至客户",
              },
              {
                title: "个性化短信提示",
                txt: "短信支持变量，内容灵活，可适应各种业务场景",
              },
            ],
          },
        },
        {
          id: 3,
          title: "客户预约挂号",
          data: {
            title: "客户预约挂号解决方案",
            content: [
              {
                title: "小程序自主预约",
                txt:
                  "提供微信、支付宝小程序快速自主预约入口，实现客户低成本便捷预约",
              },
              {
                title: "平台挂号系统",
                txt:
                  "可关联CRM系统，实现平台客户快速挂号，及新客户的便捷登记挂号",
              },
              {
                title: "预约定额配置",
                txt: "灵活配置预约配额，实现人员和资源的有效分配的最大化",
              },
            ],
          },
        },
        {
          id: 4,
          title: "客户服务消费",
          data: {
            title: "客户服务消费解决方案",
            content: [
              {
                title: "项目开单与核销",
                txt: "客户购买项目服务的销售开单系统，开单核销一体化",
              },
              {
                title: "套餐销售订购",
                txt: "通过记录客户就诊相关信息，订购客户定制化套餐",
              },
              {
                title: "销售数据统计",
                txt: "精准分析客户消费数据信息，为销售和服务提供可靠数据支撑",
              },
            ],
          },
        },
        {
          id: 5,
          title: "视频直播",
          data: {
            title: "视频直播解决方案",
            content: [
              {
                title: "商品/服务关联",
                txt: "直播中可关联推荐商品和服务，实现流量的有效变现",
              },
              {
                title: "医患直播互动",
                txt: "实现患者与医生互动，通过问答等方式在线解决疑难问题",
              },
              {
                title: "直播录像回看",
                txt: "可保存直播内容，让专业内容的无限制输出与留存",
              },
            ],
          },
        },
        {
          id: 6,
          title: "医疗服务营销",
          data: {
            title: "医疗服务营销解决方案",
            content: [
              {
                title: "小程序商城",
                txt: "依托与微信及支付宝大平台流量，使交易量和交易流程获得保障",
              },
              {
                title: "服务/卡券",
                txt: "建立服务的产品化销售模式，为客户提供一站式服务体系",
              },
              {
                title: "电商直播",
                txt:
                  "搭建自有电商直播平台，实现数字化零售转型，突破传统销售模式",
              },
            ],
          },
        },
        {
          id: 7,
          title: "企业转型",
          data: {
            title: "企业转型一站式解决方案",
            content: [
              {
                title: "产品咨询",
                txt: "为中小企业提供专业的企业转型升级以及产品构建方案",
              },
              {
                title: "品牌建设",
                txt: "提供品牌设计服务，建立自有品牌的继承与创新发展体系",
              },
              {
                title: "系统研发",
                txt: "提供多平台的软件开发服务，中后台系统开发",
              },
              {
                title: "运营推广",
                txt: "结合多年各行业经验，提供产品运营推广和业务咨询服务",
              },
            ],
          },
        },
      ],
    };
  },
  methods: {
    activeChange(data) {
      this.activeData = data;
    },
    toLink(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.solution-container {
  width: 100%;
  min-height: 705px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
  }
  .solution-body-container {
    width: 1064px;
    display: flex;
    .solution-left-bar-container {
      z-index: 9;
      transform: translateY(-70px);
      .solution-left-bar-wrapper {
        width: 300px;
        height: 610px;
        background-image: linear-gradient(0deg, #119dfd 0%, #0764fb 100%);
        margin-right: -168px;
        // z-index: 9;
        // transform: translateY(-70px);
        .solution-title {
          display: flex;
          flex-direction: column;
          padding: 40px 52px 0 52px;
          .main-title {
            font-family: PingFangSC-Semibold;
            font-size: 30px;
            color: #ffffff;
          }
          .sub-title {
            font-family: PingFangSC-Light;
            font-size: 24px;
            color: #7faeff;
          }
        }
        .detail-btn-container {
          padding: 0 40px;
          margin: 20px 0;
          .detail-btn {
            width: 104px;
            height: 34px;
            background: #ffffff;
            border-radius: 17px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #086bfb;
            @include btn;
          }
        }
        .bar-list-container {
          ul {
            li {
              height: 56px;
              line-height: 56px;
              padding-left: 40px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #ffffff;
              cursor: pointer;
              user-select: none;
              &::after {
                content: "";
                display: block;
                width: 230px;
                height: 1px;
                background: #2fa7ff;
                position: absolute;
              }
              &:first-child::before {
                content: "";
                display: block;
                width: 230px;
                height: 1px;
                background: #2fa7ff;
                position: absolute;
              }
              &:hover {
                background-image: linear-gradient(
                  270deg,
                  rgba(0, 255, 230, 0) 0%,
                  rgba(0, 255, 230, 0.2) 100%
                );
              }
            }
            .active {
              background-image: linear-gradient(
                270deg,
                rgba(0, 255, 230, 0) 0%,
                rgba(0, 255, 230, 0.6) 100%
              ) !important;
            }
          }
        }
      }
    }
    .solution-right-body-container {
      opacity: 0.9;
      .fadeInUpsolution-right-body-warpper {
        background-image: linear-gradient(180deg, #0868fc 0%, #002a69 100%);
        width: 932px;
        height: 600px;
        padding: 60px 60px 0 192px;
        box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
        border-radius: 4px;
        .right-body-title {
          font-family: PingFangSC-Semibold;
          font-size: 24px;
          color: #ffffff;
          &::after {
            content: "";
            display: block;
            width: 60px;
            height: 4px;
            background: #ffffff;
            margin: 40px 0;
          }
        }
        .solution-content-container {
          margin-bottom: 24px;
          &:not(:last-child) {
            border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          }
          .solution-content-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #ffffff;
            margin-bottom: 10px;
          }
          .solution-content-value {
            opacity: 0.7;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #ffffff;
            line-height: 26px;
            margin-bottom: 24px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/solution.vue